function groupByErrorMessage(payload) {
    return payload.Details.Error.Message;
}

export { groupByErrorMessage };
